import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

const dateFormat = 'MM/dd/yyyy';

export const dateNotBeforeFormControlDateValidator = (otherDateField: string, period?: number): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const otherControl = control?.parent?.get(otherDateField);
        if (control && otherControl) {
            const thisDate = DateTime.fromJSDate(control.value);
            const otherDate = DateTime.fromJSDate(otherControl?.value);
            if (thisDate && otherDate && thisDate.isValid && otherDate.isValid) {
                if(thisDate < otherDate){
                    return {
                        dateBeforeOtherDate: {
                            value: control.value,
                            otherDate: otherDate.toFormat(dateFormat)
                        }
                    };
                }
                if(period !== undefined && otherDate.plus({ days: period }) < thisDate){
                    return {
                        datesNotInPeriod: {
                            value: control.value,
                            otherDate: otherDate.toFormat(dateFormat),
                            period: period
                        }
                    };
                }
            }
        }
        return null;
    };
};
